import { registerOpenModal } from 'src/widgets/embed/openModal'

// Side-effect module: registers a local `gift-aid:*` handler that
// opens the inline Bootstrap 5 #giftAidModal partial when the donate
// widget is the top frame OR the channel handshake to a parent
// fails. Same shape as donate_v6/openShareModal — the v6 modal
// markup lives in the widget's DOM (with React-portaled buttons via
// GiftAidModalButtons) so this handler just calls `.show()`.
//
// In modes 2/3 with a working channel, the wildcard does not match
// at the host page (no `gift-aid:*` registered upstream), so
// openModal's default path renders the widgets/modals#gift_aid
// iframe at the host page — useGiftAid still hears the confirm via
// onModalMessage, just over the channel rather than via the local
// portal.
registerOpenModal('gift-aid:*', () => {
  const element = document.getElementById('giftAidModal')
  if (!element) throw new Error('No #giftAidModal element to open')
  bootstrap.Modal.getOrCreateInstance(element).show()
})
